import React from 'react'
import styles from './Chip.scss'
import { Icon } from 'common/Icon'

export class Chip extends React.PureComponent {
  render () {
    const { children, onDismiss } = this.props
    return (
      <div className={styles.Chip}>
        {children}
        {onDismiss && <Icon i='md-close' size={15} onClick={onDismiss} style={{ marginLeft: '15px', cursor: 'pointer' }} />}
      </div>
    )
  }
}
